// src/components/InfoBanner.js
import React from 'react';
import styled from 'styled-components';

const BannerContainer = styled.div`
  position: relative;
  padding: 4% 0px 0px 0px;
  background-color: #000000;
  text-align: center;
  max-width: 100%;

  img {
    max-width: 100%; /* 調整圖片最大寬度 */
    height: auto; /* 確保高度按比例縮放 */
  }

  h1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 52px;
    line-height: 75px;
    font-weight: 700;
    letter-spacing: 0.05em;
    color: #FFFFFF;
  }

  @media (max-width: 500px) {
    h1 {
      font-size: 36px;
      line-height: 52px;
    }
  }
`;

const DesktopBanner = styled.img`
  display: block;

  @media (max-width: 500px) {
    display: none;
  }
`;

const MobileBanner = styled.img`
  display: none;
  width: 100%;

  @media (max-width: 500px) {
    display: block;

  }
`;

const InfoBanner = () => (
  <BannerContainer>
    <DesktopBanner src="/images/pages_banner.png" alt="Desktop Banner" />
    <MobileBanner src="/images/pages_banner_mobile.png" alt="Mobile Banner" />
    <h1>相關資訊</h1>
  </BannerContainer>
);

export default InfoBanner;

